import { render, staticRenderFns } from "./KFormModelItem.vue?vue&type=template&id=51520c4e&scoped=true&"
import script from "./KFormModelItem.vue?vue&type=script&lang=js&"
export * from "./KFormModelItem.vue?vue&type=script&lang=js&"
import style0 from "./KFormModelItem.vue?vue&type=style&index=0&id=51520c4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51520c4e",
  null
  
)

export default component.exports